

















































import { Component, Vue } from 'vue-property-decorator';
import Cup from './Cup.vue';
import ClockDisplay from './ClockDisplay.vue';
import TimeInput from './TimeInput.vue';
import BackgroundTimer from "worker-loader!./backgroundTimer.worker";

@Component({
    components : {
        Cup,
        ClockDisplay,
        TimeInput
    },
    filters: {
        minutesAndSeconds: function(value: number) {
            let minutes = Math.floor(value / 60);
            let seconds = value % 60;

            return `${minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
        }        
    }
})
export default class Timer extends Vue {
    private ding: HTMLAudioElement = new Audio(require("../assets/service-bell.mp3"));
    
    private backgroundTimer = new BackgroundTimer()
    public topicTime: number = 480;
    public extensionTime: number = 0;
    public startTime: number = 0;
    public timeRemaining: number = 0;
    public extensionCount = 0;
    public currentTopic: string = "";
    public nextTopic: string = "";
    public expired: boolean = false;

    get progress() : number {
        return this.timeRemaining / this.startTime;
    }

    startTimer(time: number) {
        this.backgroundTimer.postMessage("stop");
        this.expired = false;
        this.startTime = time
        this.timeRemaining = time;
        this.backgroundTimer.onmessage = this.onTimerMessage
        this.backgroundTimer.postMessage("start");
    }

    stopTimer() {
        this.backgroundTimer.postMessage("stop");
    }

    onTimerMessage(ev: MessageEvent) {
        switch(ev.data) {
            case "tick":
                this.tick();
                break;
            default:
                console.log(`Unhandled message from background timer: ${ev.data}`)
        }

        if (ev.data != "tick")
            return
    }

    tick() {
        if (this.timeRemaining <= 1) {
            this.expired = true;
            this.ding.play();
            this.stopTimer();
        }   
        this.timeRemaining --;
    }

    startTopic() {
        this.currentTopic = this.nextTopic;
        this.nextTopic = "";
        this.extensionCount = 0;

        this.startTimer(this.topicTime)
    }

    startExtension() {
        this.extensionCount ++;
        this.startTimer(this.getExtensionTime(this.extensionCount)); 
    }

    getExtensionTime(extensionNum: number) : number {
        switch(extensionNum) {
            case 0: return this.topicTime;
            case 1: return Math.round(this.topicTime / 2);
            default: return Math.round(this.topicTime / 4);
        }
    }

    cancelTimer() {
        this.stopTimer();
        this.timeRemaining = 0;
    }
}
